import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  isUserLoggedIn: boolean = false;
  loggedInUser: string = '';
  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.authService.isUserLoggedIn$.pipe(takeUntil(this.destroy$)).subscribe(value => {
      this.isUserLoggedIn = value;

      if(value) {
        try {
          this.loggedInUser = this.authService.getTokenData('name');
        } catch (error) {
          console.error('Failed to get user name from token:', error);
          this.loggedInUser = 'User';
        }
      }
    });
  }

  onLogout() {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
